<template>
    <div @click="validationClick" >
      <b-table
        ref="table"
        :items="data"
        :fields="headers"
        responsive="sm"
        @row-clicked="toggleRowDetails"
      >
        <div v-for="(header, index) in headers" :key="index" :slot="'cell(' + header.key + ')'" slot-scope="props">
          <div class="slot-content">
            <slot :name="'cell(' + header.key + ')'" :data="props" :item="props.item" :index="props.index">
              {{ props.item[header.key] }}
            </slot>
            <div v-if="props.item._showDetails" class="additional-content">
              <slot :name="'additionalData(' + header.key + ')'" :data="props" :item="props.item" :index="props.index" />
            </div>
          </div>
        </div>
        <template v-slot:row-details="row">
          <transition name="fade">
            <div class="collapsed-content">
              <slot name="additionalData" :item="row.item" :index="row.index" />
            </div>
          </transition>
        </template>
      </b-table>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NewTable',
    props: {
      headers: {
        type: Array,
        required: true
      },
      data: {
        type: Array,
        required: true
      },
      canCollapse: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        collapsedRows: [],
        item:null,
        index:null
      };
    },
    methods: {
      validationClick(event){

        if (event.target.tagName === 'IMG') {
          return;
        }

        if (event.target.classList.contains('pointer')) {
          return;
        }

        let parent = event.target.parentNode;
        if (event.target.tagName === 'IMG' && parent.classList.contains('pointer')) {
          return
        }

        if (this.item) {
          this.collapsedRows.forEach(ele => {
            if (ele.id !== this.item.id && ele._showDetails) {
              this.$set(ele, '_showDetails', false);
            }
          });
          this.collapsedRows = [];
          this.$set(this.item, '_showDetails', !this.item._showDetails);
          this.collapsedRows.push(this.item);
        }
      },
      toggleRowDetails(item, index) {
       this.item = item;
       this.index = index;
      }
    }
  };
  </script>
  
  <style scoped>
  .collapsed-content {
    margin: -30px 0px 0px 0px;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  .slot-content {
    padding: 10px;
    font-family: Arial, sans-serif;
    width: 100%;
  }
  
  .additional-content {
    width: 100%;
  }
  
  .client-info {
    display: flex;
    flex-direction: column;
  }
  
  .client-name {
    color: #141414;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  
  .client-email-wrapper {
    display: flex;
    align-items: center;
  }
  
  .client-email {
    color: #141414;
    font-size: 15px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
  }
  
  .email-indicator {
    display: flex;
    width: 20px;
    height: 20px;
    padding: 6px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 50%;
    margin-left: 10px;
  }
  
  .email-indicator-number {
    color: #3682F3;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  
  .email-indicator.red {
    background-color: red;
  }
  
  .email-indicator.blue {
    background-color: blue;
  }
  </style>
  